module.exports = __webpack_public_path__ + "media/Resources/Nearby-ea24c63c.svg";